/**
 * Limits the number of concurrent operations to prevent overwhelming the browser
 */
export class ConcurrencyLimiter {
  private running = 0
  private queue: Array<() => void> = []

  constructor(private maxConcurrency: number = 5) {}

  async execute<T>(task: () => Promise<T>): Promise<T> {
    return new Promise((resolve, reject) => {
      this.queue.push(async () => {
        try {
          this.running++
          const result = await task()
          resolve(result)
        } catch (error) {
          reject(error)
        } finally {
          this.running--
          this.processQueue()
        }
      })

      this.processQueue()
    })
  }

  private processQueue() {
    if (this.running < this.maxConcurrency && this.queue.length > 0) {
      const task = this.queue.shift()!
      task()
    }
  }
}
